import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RestaurantPromotionsPresentationRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/restaurant-promotions-presentations/ro', { replace: true });
    }, [navigate]);

    return <p>Redirecting...</p>;
};

export default RestaurantPromotionsPresentationRedirect;
